/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React from 'react';

// eslint-disable-next-line
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'react-bootstrap';
const UnsavedDataModal = ({ showHide, className, onClick, count, path, updateModal }) => {
	let checkData = JSON.parse(localStorage.getItem('idiom'));
	let pageLanguageContent = '';
	if (checkData) {
		pageLanguageContent = checkData.OFC ? checkData.OFC : '';
	}
	return (
		<div>
			<Modal show={showHide} onHide={onClick}>
				<ModalBody>
					<Form>
						<Row>
							<Col md={12}>
								<p>{pageLanguageContent['OFC153'] ? pageLanguageContent['OFC153'] : ''}</p>
							</Col>
						</Row>
					</Form>
				</ModalBody>
				<ModalFooter>
					<Button variant='secondary' onClick={onClick}>
						{pageLanguageContent['OFC154'] ? pageLanguageContent['OFC154'] : ''}
					</Button>
					<Button variant='primary' onClick={updateModal}>
						{pageLanguageContent['OFC155'] ? pageLanguageContent['OFC155'] : ''}
					</Button>
				</ModalFooter>
			</Modal>
		</div>
	);
};

export default UnsavedDataModal;
